import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import _ from 'lodash';
import { sprinkles } from '@design-system/sprinkles.css';
import { Typography } from '@design-system/components/typography/typography';
import { DropZone } from '@design-system/components/dropZone/dropZone';
import { AddFromLibaryVM } from '../../view-models/addFromLibrary.viewModel';
import { allowedVideoTypes } from './constants';
import Upload from './upload';
import clsx from 'clsx';
import { Alert } from '@design-system/components/alert/alert';

export const SingleUpload = (p: AddFromLibaryVM) => {
  return (
    <>
      {!p.upload.validationError ? null : (
        <div className="bg-[#FFE2E2] rounded-[10px] px-4 py-3.5 flex gap-2">
          <FontAwesomeIcon
            icon={faCircleExclamation}
            className={sprinkles({ color: 'ERROR-100' })}
          />
          <div className="flex flex-col gap-2">
            <Typography variant="body" size="large">
              {p.upload.validationError.title}
            </Typography>
            <Typography variant="body" size="medium">
              {p.upload.validationError.description}
            </Typography>
          </div>
        </div>
      )}
      {p.upload.showDropZone ? (
        <div
          className={clsx(
            'flex justify-center items-center',
            p.smallerView && 'h-[180px]',
            !p.smallerView && 'h-[429px]',
          )}
        >
          <DropZone
            onChange={(files: File[]) =>
              p.dispatch('onDrop', { file: files[0], videoType: p.videoType })
            }
            accept={allowedVideoTypes}
            multiple={false}
          />
        </div>
      ) : (
        p.upload.file && (
          <Upload
            hasCustomThumbnail={p.upload.hasCustomThumbnail}
            customThumbnailUrl={p.upload.customThumbnailUrl}
            thumbnailTimestamp={p.upload.thumbnailTimestamp}
            file={p.upload.file}
            dispatch={p.dispatch}
            progress={p.upload.progress}
            step={p.upload.step}
            uploadSizeWarning={p.upload.uploadSizeWarning}
          />
        )
      )}
      <Alert
        variant="info"
        details="Once your files are uploaded, you won't be able to trim the video or remove the audio."
      />
    </>
  );
};
